// 这里写通用的请求，如果项目太复杂建议分片建立文件
import { get, post, put, Delete } from "./index"

// eg：
export function uploadTemplateAPI(data) {
    const url = "/template/upload"
    return post(url, data)
}
export function loginTestAPI(data) {
    const url = "/user-login/loginTest"
    return post(url, data)
}
//
export function findlistAll(data) {
    const url = "/template/list"
    return get(url, data)
}
//
export function findtemplateAll(data) {
    const url = `/template/get`
    // const url = `/template/get/${id}`;
    return get(url, data)
}

//
export function findkpiAll(data, id) {
    const url = `/kip_data/get/${id}`
    return get(url, data)
}
//
export function deletetemplateAPI(data) {
    const url = `/template/delete`
    return get(url, data)
}
//
export function addtemplateAll(data) {
    const url = `/template/add`
    return post(url, data)
}
//
export function updatetemplateAll(data) {
    const url = `/template/update`
    return post(url, data)
}
//
export function userlistAPI(data) {
    const url = `/kip_data/issued_list`
    return get(url, data)
}
//
export function userissuedAPI(data) {
    const url = `/template/issued`
    return post(url, data)
}
//
export function allkpiAPI(data) {
    const url = `/kip_data/my_issued_list`
    return get(url, data)
}

export function deletekpiAPI(data) {
    const url = `/kip_data/delete`
    return post(url, data)
}
//
export function picAPI(data) {
    const url = `/file/single`
    return post(url, data)
}
//
export function getUserInfo(data) {
    const url = `/user-login/login`
    return post(url, data)
}
//
export function getdeparmentlist(data) {
    const url = `/dept/list`
    return get(url, data)
}
//
export function joinlistAPI(data) {
    const url = `/dept/join`
    return post(url, data)
}
//
export function updatekpiAPI(data) {
    const url = `/kip_data/update`
    return post(url, data)
}
//
export function mykpiAPI(data) {
    const url = `/kip_data/my_list`
    return get(url, data)
}
//
export function grantAPI(data) {
    const url = `/user-login/grant`
    return post(url, data)
}
//view获取数据
export function getuserlistAPI(data) {
    const url = "/user-login/get-grant"
    return get(url, data)
}
//view获取数据
export function getuserinfoAPI(data) {
    const url = "/user-login/user-info"
    return get(url, data)
}
//上传文件
export function fileUpload(data) {
    const url = "https://api.workingmanual.com/api/common/file/upload"
    return post(url, data)
}
//新增二级模板
export function addsecondModel(data) {
    const url = "kpiSecondModel/addModel"
    return post(url, data)
}
//修改二级模板
export function updatesecondModel(data) {
    const url = "kpiSecondModel/updateModel"
    return post(url, data)
}
//删除二级模板
export function deletesecondModel(data) {
    const url = "kpiSecondModel/deleteModel"
    return get(url, data)
}
//新增三级模板
export function threeaddModel(data) {
    const url = "kpiThirdModel/addModel"
    return post(url, data)
}
//修改三级模板
export function threeupdateModel(data) {
    const url = "kpiThirdModel/updateModel"
    return post(url, data)
}
//删除三级模板
export function threedeleteModel(data) {
    const url = "kpiThirdModel/deleteModel"
    return get(url, data)
}
//修改其他数据（上级建议、绩效等级...）
export function updateKpiData(data) {
    const url = "kip_data/updateKpiData"
    return post(url, data)
}
//修改模板其他数据（上级建议、绩效等级...）
export function updateTemData(data) {
    const url = "template/update"
    return post(url, data)
}
//封存数据
export function dataArchive(data) {
    const url = "kip_data/dataArchive"
    return get(url, data)
}
//修改模板名称
export function updateTemplateTitle(data) {
    const url = "template/updateTemplateTitle"
    return get(url, data)
}
//修改模板名称获取挑战性任务
export function getChallengeList(data) {
    const url = "template/getChallengeList"
    return get(url, data)
}
//获取挑战性任务的评论
export function getChangeCommentList(data) {
    const url = "challengeComment/getCommentList"
    return get(url, data)
}
//新增挑战性任务的评论
export function addChangeComment(data) {
    const url = "challengeComment/addComment"
    return post(url, data)
}
//删除挑战性任务的评论
export function deleteChangeComment(data) {
    const url = "challengeComment/deleteComment"
    return get(url, data)
}
//修改关键指标锁
export function updateKeyLock(data) {
    const url = "/kip_data/updateKeyLock"
    return post(url, data)
}
//获取全部kpi
export function getmankpiAPI(data) {
    const url = "/kip_data/root_list"
    return get(url, data)
}
// 获取上一条或下一条KPI
export function getNextOrPreviewAPI(data) {
    const url = "/kip_data/getNextOrPreview"
    return get(url, data)
}
// 根据年月获取用户某个月的KPI（上月 / 本月）
export function getUserKpiByDateAPI(data) {
    const url = "/kip_data/getUserKpiByDate"
    return get(url, data)
}
//获取姓氏列表
export function getSurnameListAPI(data) {
    const url = "/surname/getList"
    return get(url, data)
}
//新增或更新姓氏
export function addOrUpdateSurnameAPI(data) {
    const url = "/surname/addOrUpdate"
    return get(url, data)
}
//删除姓氏
export function deleteSurnameAPI(data) {
    const url = "/surname/delete"
    return get(url, data)
}
//个人提交kpi
export function submitKpiAPI(data) {
    const url = "/kip_data/submitKpi"
    return get(url, data)
}

// 审核人查看每一项KPI的AI初审意见
export function getKpiAiReviewAPI(data) {
    const url = "/kpi-ai-review/list"
    return get(url, data)
}
